import { useUserStore } from "@/store/criarUserStore";
import { storeToRefs } from "pinia";

export function useModeloQuestao() {
    const store = useUserStore();
    const { usuarioId, disciplinaId } = storeToRefs(store);

    return {
        fonte: 1,
        proprietario: usuarioId.value,
        tipo: 1,
        conceitos: null,
        disciplina: disciplinaId.value,
        imagem: "",
        texto: "",
        pergunta: "",
        a: "",
        b: "",
        c: "",
        d: "",
        e: "",
        gabarito: "",
        numero_vez_usado: 0,
        numero_erros: 0,
        numero_acertos: 0,
        dificuldade: null,
        nivel_complexidade: null,
        id: null
    };
}
